<template>
    <a-modal v-model="visible" width="900px" :title="$t('submission.abstract_audit.title' /*稿件审核*/)" :footer="null" centered @cancel="handleCancelEvent" class="modal-box">
        <div class="preview-box mt15">
            <!-- 主题分类 -->
            <p class="flex x-left">
                <span class="color999">{{ $t('submission.abstract_audit.topic_category' /*主题分类*/) }}：</span>
                <span class="color000">{{ info.publish_type }}</span>
            </p>
            <h2 class="mt20 t-c">{{ info.title }}</h2>
            <!-- 作者列表 -->
            <p class="mt30 t-c fs12" v-if="info?.author_list?.length > 0">
                <template v-for="(item, index) in info.author_list">
                    <sup v-if="info.author_list.length > 1">{{ index + 1 }}</sup>
                    <u>{{ item.real_name }}</u>
                </template>
            </p>
            <!-- 单位 地址 邮编 邮箱 -->
            <p style="font-style: italic" class="mt30 t-c fs12" v-for="(item, index) in info.organize_list" :key="index">
                <sup>{{ item.author_nums }}</sup>
                <span>{{ item.org_cnname }}</span>
                <span class="ml10">{{ item.address }}</span>
                <span class="ml10">{{ item.zipcode }}</span>
                <span class="ml10">{{ item.author_emails }}</span>
            </p>
            <!-- 摘要 -->
            <div class="mt20">
                <span class="color999">{{ $t('submission.abstract_audit.abstract' /*摘要*/) }}：</span>
                <div v-for="(item, index) in info.other_infos" :key="index" v-html="item"></div>
            </div>
            <!-- 关键字 -->
            <div class="mt10">
                <span class="color999">{{ $t('submission.abstract_audit.keywords' /*关键字*/) }}：</span>
                <div>
                    {{ info.keywords }}
                </div>
            </div>
        </div>
        <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" class="mt20">
            <a-form-item :label="$t('submission.abstract_audit.audit_opinion' /*审核意见*/)">
                <a-textarea v-model="remark" :placeholder="$t('submission.abstract_audit.enter_audit_opinion' /*请输入审核意见*/)"></a-textarea>
            </a-form-item>
        </a-form>
        <div class="t-r">
            <a-button type="primary" @click="handleSubmitEvent(1)">{{ $t('submission.abstract_audit.approve' /*通过*/) }}</a-button>
            <a-button class="ml10" type="danger" @click="handleSubmitEvent(0)">{{ $t('submission.abstract_audit.reject' /*驳回*/) }}</a-button>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: 'AbstractAudit',
    components: {},
    data() {
        return {
            info: {},
            visible: false,
            remark: ''
        };
    },
    computed: {},
    methods: {
        show(id) {
            this.visible = true;
            this.$request.post({ url: 'getAbstractListDetail', data: { abstract_id: id, show_author: 1, show_annex: 0 } }).then(res => {
                const { data } = res;
                this.info = data;
            });
        },
        handleCancelEvent() {
            this.visible = false;
        },
        handleSubmitEvent(type) {
            console.log(this.info);
            let data = {
                status: type,
                remark: this.remark,
                id: this.info.id
            };
            this.$request.post({ url: 'submitAbstractAudit', data: data }).then(res => {
                this.$message.success(this.$t('submission.abstract_audit.submit_success' /*提交成功*/));
                this.visible = false;
            });
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped>
.preview-box {
    padding: 30px;
    background-color: #f9f9f9;
}
</style>
